export enum VendorActionTypes {
    API_RESPONSE_SUCCESS = '@@vendor/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@vendor/API_RESPONSE_ERROR',

    GET_VENDORS = '@@vendor/GET_VENDORS',
    GET_VENDOR_BY_ID = '@@vendor/GET_VENDOR_BY_ID',
    ADD_VENDOR = '@@vendor/ADD_VENDOR',
    UPDATE_VENDOR = '@@vendor/UPDATE_VENDOR',
    DELETE_VENDOR = '@@vendor/DELETE_VENDOR',

    RESET = '@@vendor/RESET',
}